/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const FeeRangeR = t.interface({
  min: t.Integer,

  max: t.Integer
});

// optional attributes
const FeeRangeO = t.partial({});

export const FeeRange = t.intersection([FeeRangeR, FeeRangeO], "FeeRange");

export type FeeRange = t.TypeOf<typeof FeeRange>;
